module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/95/assets/images/37009227f57f17c09c5ced382bcb598d.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Platinum/Platinum3.svg
// module id = /tNG
// module chunks = 1